<button
  mat-button
  class="vzc-spinner-button"
  [class.mat-flat-button]="color === defaultColor"
  [disabled]="isDisabled"
  [color]="color"
  (click)="emitClickFunction()"
>
  <mat-spinner diameter="24" *ngIf="isSpinning"></mat-spinner>
  <span class="vzc-spinner-button__label">
    {{ label }}
  </span>
</button>
